module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/readers/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Olvasó")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "id": "controller_id",
      "label": "Kontroller",
      "errors": _vm.errors,
      "name": "controller_id",
      "options": _vm.controllers
    },
    model: {
      value: (_vm.form.controller_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "controller_id", $$v)
      },
      expression: "form.controller_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "building_id",
      "label": "Épület",
      "errors": _vm.errors,
      "name": "building_id",
      "options": _vm.buildings,
      "change": _vm.buildingChange
    },
    model: {
      value: (_vm.form.building_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "building_id", $$v)
      },
      expression: "form.building_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "building_level_id",
      "label": "Épület szint",
      "errors": _vm.errors,
      "name": "building_level_id",
      "options": _vm.building_levels
    },
    model: {
      value: (_vm.form.building_level_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "building_level_id", $$v)
      },
      expression: "form.building_level_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9]+",
      "id": "x_coord",
      "label": "X koordináta",
      "errors": _vm.errors,
      "name": "x_coord"
    },
    model: {
      value: (_vm.form.x_coord),
      callback: function($$v) {
        _vm.$set(_vm.form, "x_coord", $$v)
      },
      expression: "form.x_coord"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9]+",
      "id": "y_coord",
      "label": "Y koordináta",
      "errors": _vm.errors,
      "name": "y_coord"
    },
    model: {
      value: (_vm.form.y_coord),
      callback: function($$v) {
        _vm.$set(_vm.form, "y_coord", $$v)
      },
      expression: "form.y_coord"
    }
  })], 1)]), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "controller_line",
      "label": "Vonal",
      "errors": _vm.errors,
      "name": "controller_line"
    },
    model: {
      value: (_vm.form.controller_line),
      callback: function($$v) {
        _vm.$set(_vm.form, "controller_line", $$v)
      },
      expression: "form.controller_line"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9.]+",
      "id": "reader_address",
      "label": "Olvasó cím",
      "errors": _vm.errors,
      "name": "reader_address"
    },
    model: {
      value: (_vm.form.reader_address),
      callback: function($$v) {
        _vm.$set(_vm.form, "reader_address", $$v)
      },
      expression: "form.reader_address"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9.]+",
      "id": "reader_comm_address",
      "label": "Kommunikációs cím",
      "errors": _vm.errors,
      "name": "reader_comm_address"
    },
    model: {
      value: (_vm.form.reader_comm_address),
      callback: function($$v) {
        _vm.$set(_vm.form, "reader_comm_address", $$v)
      },
      expression: "form.reader_comm_address"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b898c8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/reader.vue
// module id = 304
// module chunks = 0